import { useNavigate } from "react-router-dom";
import { ArrowLeft, Linkedin } from "lucide-react";
import Header from "@/components/Header";
import QuoteBanner from "@/components/QuoteBanner";
import Footer from "@/components/Footer";
import { useLang } from "@/context/LangContext";

export default function About() {
  const { t, lang } = useLang();
  const navigate = useNavigate();
  const ta = lang === "ta";

  return (
    <div className="App">
      <Header compact />
      <QuoteBanner />

      <main className="max-w-2xl mx-auto px-6 pt-6 pb-24">

        <button
          onClick={() => navigate(-1)}
          className={`mt-6 mb-4 inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-[13px] font-semibold text-[#1a1640] shadow-sm hover:bg-[#f3eedc] active:scale-[0.99] transition ${
            ta ? "font-tamil" : ""
          }`}
          data-testid="about-back-btn"
        >
          <ArrowLeft size={16} strokeWidth={2.4} />
          {t("contact_back")}
        </button>

        <h1
          className={`text-3xl sm:text-4xl font-semibold text-[#1a1640] tracking-tight ${
            ta ? "font-tamil" : "font-display"
          }`}
          data-testid="about-title"
        >
          {t("about_title")}
        </h1>

        <article
          className="mt-6 bg-white rounded-[22px] p-6 sm:p-8 shadow-sm"
          data-testid="about-card"
        >
          {/* Header with avatar + name */}
          <div className="flex items-center gap-4">
            <div
              className="w-16 h-16 sm:w-20 sm:h-20 rounded-full flex items-center justify-center font-display font-bold text-white text-2xl sm:text-3xl tracking-tight shrink-0"
              style={{
                background: "linear-gradient(135deg,#1e1859 0%,#5b21b6 100%)",
                boxShadow: "0 10px 24px -12px rgba(30,24,89,.5)",
              }}
              aria-hidden
            >
              KB
            </div>
            <div className="min-w-0 flex-1">
              <div
                className={`text-[22px] sm:text-[26px] font-semibold text-[#1a1640] leading-tight tracking-tight ${
                  ta ? "font-tamil" : "font-display"
                }`}
                data-testid="about-name"
              >
                {t("about_name")}
              </div>
              <div className={`mt-1 text-[13px] text-[#6b6894] ${ta ? "font-tamil" : ""}`}>
                {t("about_subtitle")}
              </div>
              <a
                href="https://www.linkedin.com/in/kapil-bhaskar-2572aa291/"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-2.5 inline-flex items-center gap-1.5 rounded-full bg-[#0a66c2] hover:bg-[#0958a9] text-white text-[12px] font-semibold px-3 py-1.5 transition active:scale-[0.98]"
                data-testid="about-linkedin-btn"
                aria-label="Follow Kapil on LinkedIn"
              >
                <Linkedin size={13} strokeWidth={2.4} />
                {ta ? "LinkedIn-இல் பின்தொடருங்கள்" : "Follow on LinkedIn"}
              </a>
            </div>
          </div>

          {/* Interest chips */}
          <div className="mt-5 flex flex-wrap gap-2">
            {[
              { icon: "🏏", en: "Cricket", ta: "கிரிக்கெட்" },
              { icon: "🏀", en: "Basketball", ta: "பாஸ்கெட்பால்" },
              { icon: "💛", en: "CSK — Whistle Podu!", ta: "CSK — விசில் போடு!" },
              { icon: "📊", en: "Statistics", ta: "புள்ளியியல்" },
            ].map((it) => (
              <span
                key={it.en}
                className="inline-flex items-center gap-1.5 rounded-full bg-[#f3eedc] text-[#1a1640] text-[13px] font-semibold px-3 py-1.5"
              >
                <span aria-hidden>{it.icon}</span>
                <span className={ta ? "font-tamil" : ""}>{ta ? it.ta : it.en}</span>
              </span>
            ))}
          </div>

          <div className="mt-6 h-px bg-[#e9e5f5]" />

          {/* Bio paragraphs */}
          <div className={`mt-6 space-y-4 text-[15px] sm:text-[16px] leading-relaxed text-[#2a2550] ${ta ? "font-tamil" : ""}`}>
            <p data-testid="about-para-1">{t("about_p1")}</p>
            <p data-testid="about-para-2">{t("about_p2")}</p>
            <p data-testid="about-para-3">{t("about_p3")}</p>
          </div>
        </article>
      </main>

      <Footer />
    </div>
  );
}
